/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DoubleTick from './icon-double-tick.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DoubleTick {...validProps} />;
}
SvgComponent.iconName = 'double-tick';

export const DoubleTickIcon = svgIconWrapper(SvgComponent);
